import { render, staticRenderFns } from "./DxPostWorkSelectSupervisor.vue?vue&type=template&id=0932b452&"
import script from "./DxPostWorkSelectSupervisor.vue?vue&type=script&lang=js&"
export * from "./DxPostWorkSelectSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./DxPostWorkSelectSupervisor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports